<template>
  <Checkbox v-model="isChecked" :indeterminate="isIndeterminate" class="mb-2" binary @update:model-value="handleCheckboxChange" />
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const isChecked = ref<boolean | null>(props.params.value);
const isIndeterminate = ref<boolean>(isChecked.value == null);
const indeterminateNext = ref<boolean>(!isIndeterminate.value && isChecked.value == false);

const handleCheckboxChange = (): void => {
  if (isChecked.value == true) {
    if (indeterminateNext.value) {
      isChecked.value = null;
      indeterminateNext.value = false;
      isIndeterminate.value = true;
    } else {
      indeterminateNext.value = true;
      isIndeterminate.value = false;
    }
  }

  props.params.setValue(props.params.node.rowIndex, isChecked.value);
};
</script>
